import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function DeleteModal({ 
  showdt, 
  handleCloseDt, 
  handledelete, 
  title = "Delete", 
  message = "Are you sure you want to delete this record ?" 
}) {
  return (
    <Modal
      show={showdt}
      size="md"
      onHide={handleCloseDt}
      centered
      backdrop="static"
      className="add_subproduct msl_model"
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="font_blue_20 font-600">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <p className="font_blue_18">{message}</p>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        <Button variant="danger" className="success_btn" onClick={handledelete}>
          Delete
        </Button>
        <Button variant="secondary" className="cancel_btn" onClick={handleCloseDt}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}